
export function getToken() {
    let info = JSON.parse(sessionStorage.getItem("userInfo"))
    if (info == null) {
        return null;
    }
    return info.token;
}

export function getId() {
    let id = JSON.parse(sessionStorage.getItem("userInfo")).id;
    return id;
}


// WEBPACK FOOTER //
// ./src/utils/auth.js